import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserDocuments = userId =>
  call(websocketFetch, 'get_user_documents', { user_id: userId });
